import React, { Component, ComponentType } from 'react';
import ErrorBoundary from './ErrorBoundry';

const SafeComponentWrapper = <P extends object>(WrappedComponent: ComponentType<P>) => {
    // eslint-disable-next-line react/prefer-stateless-function
    class SafeComponent extends Component<P> {
        override render() {
            return (
                <ErrorBoundary>
                    <WrappedComponent {...this.props} />
                </ErrorBoundary>
            );
        }
    }

    return SafeComponent;
};

export default SafeComponentWrapper;
